import PageHeader from 'components/layout/page-header'
import { SavedReportsTable } from 'components/timenotes/saved-reports/saved-reports-table'
import { TApiSavedReportKind } from '@timenotes/shared/src/services/saved-reports/saved-reports-types'
import { useTimesheetsTopNavigationLinks } from './hooks/use-timesheets-top-navigation-links'
import { SavedReportsFilters, useSavedReportsFilters } from '../reports/components/saved-reports-filters'

export function SavedTimesheetsPage() {
  useTimesheetsTopNavigationLinks()

  const [filters, setFilters] = useSavedReportsFilters({
    kind: 'timesheet' as TApiSavedReportKind
  })

  return (
    <>
      <div className="page-content">
        <PageHeader
          title="Saved Timesheets"
          buttons={[]}
        />
      </div>

      <div className="page-content" style={{ marginLeft: '5px', marginRight: '5px' }}>
        <SavedReportsFilters
          initialValues={filters}
          onFiltersChange={(newFilters) => {
            setFilters(prev => ({
              ...prev,
              name: newFilters.name,
              visibility: newFilters.visibility
            }))
          }}
        />
        
        <div style={{ marginTop: '1rem' }}>
          <SavedReportsTable 
            filters={filters}
          />
        </div>
      </div>
    </>
  )
}